import type { ReactNode } from 'react'

export function Tap({
  selected,
  className = '',
  children,
  ...rest
}: {
  selected: boolean
  className?: string
  children: ReactNode
} & Omit<React.ButtonHTMLAttributes<HTMLButtonElement>, 'children'>) {
  return (
    <button
      type="button"
      aria-pressed={selected}
      className={[
        'ui-pressable flex shrink-0 cursor-pointer items-center justify-center rounded-[18px] border-0 py-2.5 text-body-sm font-medium whitespace-nowrap',
        selected
          ? 'bg-violet-500 px-3 leading-[1.32] text-violet-50'
          : 'h-[38px] bg-violet-50 px-3.5 leading-[1.6] text-black-200',
        className,
      ]
        .filter(Boolean)
        .join(' ')}
      {...rest}
    >
      {children}
    </button>
  )
}
